import axios from "axios";

import { to } from "../../helpers/api";

export const leaderboard = {
  getLeaderboard: (data) => {
    return axios.get(to(`leaderboard/${data}`));
  },
};
